import { useState, useCallback } from 'react';
import axios from 'axios';

const useIFSCLookup = () => {
    const [isIfscLoading, setIsIfscLoading] = useState(false);

    const debounce = useCallback((func, wait) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), wait);
        };
    }, []);

    const lookupIFSC = useCallback(async (ifscCode, onSuccess, onError) => {
        if (!ifscCode || ifscCode.length !== 11) return;

        setIsIfscLoading(true);
        try {
            const response = await axios.get(`https://ifsc.razorpay.com/${ifscCode}`);
            if (response?.data) {
                onSuccess(response.data);
            }
        } catch (error) {
            onError('Invalid IFSC code');
        } finally {
            setIsIfscLoading(false);
        }
    }, []);

    const debouncedLookupIFSC = useCallback(
        debounce(lookupIFSC, 500),
        [lookupIFSC]
    );

    return {
        isIfscLoading,
        debouncedLookupIFSC
    };
};

export default useIFSCLookup;
